import './index.styl';
import template from './index.jst';
import { Bench } from '../../../views';

export class ListOfBench extends Bench {
	get template() {
		return template;
	}

	get className() {
		return 'view-player-bench-container';
	}
}

export default ListOfBench;